// JQ4-38 · US-PAGOS-004 — useRegisterCashPayment hook (WU-4)
//
// Wraps POST /valet/tickets/:id/cash-payment.
// On success: the caller applies an optimistic update from the response payload
//   (no GET refetch — REQ-7, Scenario 7.4).
// On error: the caller surfaces the error message in the dialog.

import { registerCashPayment } from '@jq4race/api-client';
import { useMutation } from '@tanstack/react-query';

interface RegisterCashPaymentVars {
  ticketId: string;
  amountCents: number;
}

export function useRegisterCashPayment() {
  return useMutation({
    mutationFn: ({ ticketId, amountCents }: RegisterCashPaymentVars) =>
      registerCashPayment(ticketId, amountCents),
  });
}
